export enum TicketRedemptionStatus {
    SUCCESS = "success",
    DUPLICATE = "duplicate",
    NOT_AUTHORIZED = "not_authorized",
    PURCHASE_EXPIRED = "purchase_expired",
    CHECKIN_EXPIRED = "checkin_expired",
    INVALID_CODE = "invalid_code",
    PAYMENT_DUE = "payment_due",
    CANCELED = "canceled",
}

export const TicketRedemptionStatusCopy: { [key in TicketRedemptionStatus]: string } = {
    [TicketRedemptionStatus.SUCCESS]: "Success",
    [TicketRedemptionStatus.DUPLICATE]: "Duplicate",
    [TicketRedemptionStatus.NOT_AUTHORIZED]: "Not authorized",
    [TicketRedemptionStatus.PURCHASE_EXPIRED]: "Purchase expired",
    [TicketRedemptionStatus.CHECKIN_EXPIRED]: "Check-in expired",
    [TicketRedemptionStatus.INVALID_CODE]: "Invalid code",
    [TicketRedemptionStatus.PAYMENT_DUE]: "Payment due",
    [TicketRedemptionStatus.CANCELED]: "Booking canceled",
};

export const getTicketRedemptionStatus = (status: string) => {
    const ticketStatus: TicketRedemptionStatus = status as TicketRedemptionStatus;

    if (TicketRedemptionStatusCopy[ticketStatus]) {
        return TicketRedemptionStatusCopy[ticketStatus];
    }

    return ticketStatus;
};

export interface FilterParamTicketRedemptionStatus {
    key: TicketRedemptionStatus;
    value: string;
}

export const getAllTicketRedemptionStatus = (): FilterParamTicketRedemptionStatus[] => {
    const allTicketRedemptionStatus: FilterParamTicketRedemptionStatus[] = [];
    const ticketRedemptionStatus = Object.values(TicketRedemptionStatus);

    for (const status of ticketRedemptionStatus) {
        allTicketRedemptionStatus.push({ key: status, value: TicketRedemptionStatusCopy[status] });
    }

    return allTicketRedemptionStatus;
};
